import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as dashboardActions from './dashboard.actions';
import { tap } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '../studies/components/confirmation-dialog/confirmation-dialog.component';

@Injectable()
export class DashboardEffects {
  openDashboardConfirmationDialog$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(dashboardActions.openDashboardConfirmationDialog),
        tap(({ dialogData }) => this.dialog.open(ConfirmationDialogComponent, { data: dialogData }))
      ),
    { dispatch: false }
  );

  constructor(private actions$: Actions, private dialog: MatDialog) {}
}
